import React, { useState } from "react";
import "./Namuna8Form.css";

const BUILDING_RATES = {
  "आर. सी. सी.": 50,
  "ईंट": 35,
  "इतर": 25,
};

const Namuna8Form = ({ onClose }) => {
  const [basicInfo, setBasicInfo] = useState({
    ownerName: "",
    mobile: "",
    ward: "",
    road: "",
  });

  const [property, setProperty] = useState({
    description: "",
    buildingType: "आर. सी. सी.",
    length: "",
    width: "",
    area: 0,
    usage: "रहिवासी",
    constructionYear: "",
    rate: BUILDING_RATES["आर. सी. सी."],
    amount: 0,
  });

  const [rows, setRows] = useState([]);

  // 🔹 Basic info change
  const handleBasicChange = (e) => {
    setBasicInfo({ ...basicInfo, [e.target.name]: e.target.value });
  };

  // 🔹 Property change
  const handlePropertyChange = (e) => {
    const { name, value } = e.target;

    let updated = { ...property, [name]: value };

    // area calculation
    if (name === "length" || name === "width") {
      const l = name === "length" ? value : property.length;
      const w = name === "width" ? value : property.width;
      updated.area = l && w ? Math.round(l * w * 100) / 100 : 0;
    }

    // rate change by building type
    if (name === "buildingType") {
      updated.rate = BUILDING_RATES[value];
    }

    // amount calculation
    updated.amount = Math.round(updated.area * updated.rate * 100) / 100;

    setProperty(updated);
  };

  // 🔹 Add row to table
  const addProperty = () => {
    if (!property.description || !property.length || !property.width) {
      alert("कृपया सर्व आवश्यक माहिती भरा!");
      return;
    }

    setRows([
      ...rows,
      {
        ...property,
        id: Date.now(),
      },
    ]);

    setProperty({
      description: "",
      buildingType: "आर. सी. सी.",
      length: "",
      width: "",
      area: 0,
      usage: "रहिवासी",
      constructionYear: "",
      rate: BUILDING_RATES["आर. सी. सी."],
      amount: 0,
    });
  };

  // 🔹 Delete row
  const deleteRow = (id) => {
    setRows(rows.filter((r) => r.id !== id));
  };

  const totalAmount = rows.reduce((sum, r) => sum + r.amount, 0);

  const handleSave = () => {
    if (rows.length === 0) {
      alert("कृपया कमीतकमी एक मालमत्ता जोडा!");
      return;
    }

    const formData = {
      basicInfo,
      properties: rows,
      totalAmount,
      createdAt: new Date().toLocaleDateString("en-GB"),
    };

    console.log("Form Data:", formData);
    alert("डेटा यशस्वीरित्या सेव्ह झाला! ✅");
    
    // Reset form
    setBasicInfo({ ownerName: "", mobile: "", ward: "", road: "" });
    setRows([]);
  };

  return (
    <div className="namuna8-modal-overlay">
      <div className="namuna8-modal">
        <div className="namuna8-header">
          <h2>नमुना नं ८ – नवीन माहिती भरणे</h2>
          <button className="namuna8-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="namuna8-content">
          {/* BASIC INFO */}
          <div className="namuna8-section">
            <h4 className="namuna8-section-title">📋 माहिती</h4>

            <div className="namuna8-grid-2">
              <div className="namuna8-field">
                <label>मालकाचे नाव <span className="required">*</span></label>
                <input
                  type="text"
                  name="ownerName"
                  placeholder="मालकाचे नाव"
                  value={basicInfo.ownerName}
                  onChange={handleBasicChange}
                />
              </div>

              <div className="namuna8-field">
                <label>मोबाईल नं.</label>
                <input
                  type="tel"
                  name="mobile"
                  placeholder="मोबाईल नं."
                  value={basicInfo.mobile}
                  onChange={handleBasicChange}
                />
              </div>

              <div className="namuna8-field">
                <label>वॉर्ड</label>
                <input
                  type="text"
                  name="ward"
                  placeholder="वॉर्ड"
                  value={basicInfo.ward}
                  onChange={handleBasicChange}
                />
              </div>

              <div className="namuna8-field">
                <label>रस्त्याचे नाव</label>
                <input
                  type="text"
                  name="road"
                  placeholder="रस्त्याचे नाव"
                  value={basicInfo.road}
                  onChange={handleBasicChange}
                />
              </div>
            </div>
          </div>

          {/* PROPERTY DETAILS */}
          <div className="namuna8-section">
            <h4 className="namuna8-section-title">🏠 मालमत्ता तपशील</h4>

            <div className="namuna8-grid-1">
              <div className="namuna8-field">
                <label>मालमत्तेचे वर्णन <span className="required">*</span></label>
                <input
                  type="text"
                  name="description"
                  placeholder="मालमत्तेचे वर्णन"
                  value={property.description}
                  onChange={handlePropertyChange}
                />
              </div>
            </div>

            <div className="namuna8-grid-2">
              <div className="namuna8-field">
                <label>इमारत प्रकार <span className="required">*</span></label>
                <select
                  name="buildingType"
                  value={property.buildingType}
                  onChange={handlePropertyChange}
                >
                  {Object.keys(BUILDING_RATES).map((type) => (
                    <option key={type}>{type}</option>
                  ))}
                </select>
              </div>

              <div className="namuna8-field">
                <label>उपयोग प्रकार <span className="required">*</span></label>
                <select
                  name="usage"
                  value={property.usage}
                  onChange={handlePropertyChange}
                >
                  <option>रहिवासी</option>
                  <option>वाणिज्यिक</option>
                  <option>औद्योगिक</option>
                </select>
              </div>
            </div>

            <div className="namuna8-grid-2">
              <div className="namuna8-field">
                <label>लांबी (फूट) <span className="required">*</span></label>
                <input
                  type="number"
                  name="length"
                  placeholder="लांबी"
                  value={property.length}
                  onChange={handlePropertyChange}
                  step="0.01"
                />
              </div>

              <div className="namuna8-field">
                <label>रुंदी (फूट) <span className="required">*</span></label>
                <input
                  type="number"
                  name="width"
                  placeholder="रुंदी"
                  value={property.width}
                  onChange={handlePropertyChange}
                  step="0.01"
                />
              </div>
            </div>

            <div className="namuna8-grid-2">
              <div className="namuna8-field">
                <label>क्षेत्रफळ (चौ.फूट)</label>
                <input
                  type="text"
                  value={property.area}
                  readOnly
                  placeholder="क्षेत्रफळ"
                  className="read-only"
                />
              </div>

              <div className="namuna8-field">
                <label>बांधकाम वर्ष</label>
                <input
                  type="number"
                  name="constructionYear"
                  placeholder="बांधकाम वर्ष"
                  value={property.constructionYear}
                  onChange={handlePropertyChange}
                />
              </div>
            </div>

            <div className="namuna8-calc-info">
              <div className="calc-item">
                <span>दर (प्रति चौ.फूट):</span>
                <strong>₹ {property.rate}</strong>
              </div>
              <div className="calc-item">
                <span>एकूण रक्कम:</span>
                <strong>₹ {property.amount}</strong>
              </div>
            </div>

            <button className="namuna8-btn-add" onClick={addProperty}>
              ➕ मालमत्ता जोड करा
            </button>
          </div>

          {/* TABLE */}
          {rows.length > 0 && (
            <div className="namuna8-section">
              <h4 className="namuna8-section-title">📊 मालमत्ता यादी</h4>

              <div className="namuna8-table-wrapper">
                <table className="namuna8-table">
                  <thead>
                    <tr>
                      <th>अ.क्र.</th>
                      <th>वर्णन</th>
                      <th>इमारत प्रकार</th>
                      <th>क्षेत्रफळ</th>
                      <th>दर</th>
                      <th>रक्कम</th>
                      <th>क्रिया</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((r, i) => (
                      <tr key={r.id}>
                        <td>{i + 1}</td>
                        <td>{r.description}</td>
                        <td>{r.buildingType}</td>
                        <td>{r.area}</td>
                        <td>₹ {r.rate}</td>
                        <td>₹ {r.amount}</td>
                        <td>
                          <button
                            className="namuna8-btn-delete"
                            onClick={() => deleteRow(r.id)}
                          >
                            हटवा
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="namuna8-total">
                <h4>एकूण कर : <strong>₹ {totalAmount.toFixed(2)}</strong></h4>
              </div>
            </div>
          )}
        </div>

        <div className="namuna8-footer">
          <button className="namuna8-btn-save" onClick={handleSave}>
            💾 जतन करा
          </button>
          <button className="namuna8-btn-cancel" onClick={onClose}>
            रद्द करा
          </button>
        </div>
      </div>
    </div>
  );
};

export default Namuna8Form;
